module.exports = __webpack_public_path__ + "static/img/91BM-049-AllenZhao.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stars/91BM-049-AllenZhao.jpg
// module id = j/7o
// module chunks = 0